export const InputMethods = {
  URL_Download: _TL_('URL Download'),
  FTP_Upload: _TL_('FTP Upload'),
  Manual_Upload: _TL_('Manual Upload'),
  // FIXME: Confirm with MT staff
  Google_Import: _TL_('Google Import'),
};
